import { render, staticRenderFns } from "./CreateEditFormNode.vue?vue&type=template&id=0ca85527"
import script from "./CreateEditFormNode.vue?vue&type=script&lang=js"
export * from "./CreateEditFormNode.vue?vue&type=script&lang=js"
import style0 from "./CreateEditFormNode.vue?vue&type=style&index=0&id=0ca85527&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports